var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import React from 'react';
import ReactPlayer from 'react-player';
import { AttachmentActions as DefaultAttachmentActions, } from './AttachmentActions';
import { Audio as DefaultAudio } from './Audio';
import { Card as DefaultCard } from './Card';
import { FileAttachment as DefaultFile } from './FileAttachment';
import { isAudioAttachment, isFileAttachment, isGalleryAttachment, isImageAttachment, isMediaAttachment, renderAudio, renderCard, renderFile, renderGallery, renderImage, renderMedia, } from './utils';
import { Gallery as DefaultGallery, ImageComponent as DefaultImage, } from '../Gallery';
/**
 * Attachment - The message Attachment. A message can contain multiple Attachments.
 * By default, the component supports:
 * - AttachmentActions
 * - Audio
 * - Card
 * - File
 * - Gallery
 * - Image
 * - Media (video)
 *
 * @example ./Attachment.md
 */
export var Attachment = function (props) {
    var _a;
    var _b = props.AttachmentActions, AttachmentActions = _b === void 0 ? DefaultAttachmentActions : _b, attachments = props.attachments, _c = props.Audio, Audio = _c === void 0 ? DefaultAudio : _c, _d = props.Card, Card = _d === void 0 ? DefaultCard : _d, _e = props.File, File = _e === void 0 ? DefaultFile : _e, _f = props.Gallery, Gallery = _f === void 0 ? DefaultGallery : _f, _g = props.Image, Image = _g === void 0 ? DefaultImage : _g, _h = props.Media, Media = _h === void 0 ? ReactPlayer : _h, rest = __rest(props, ["AttachmentActions", "attachments", "Audio", "Card", "File", "Gallery", "Image", "Media"]);
    var gallery = {
        images: attachments === null || attachments === void 0 ? void 0 : attachments.filter(function (attachment) {
            return attachment.type === 'image' && !(attachment.og_scrape_url || attachment.title_link);
        }),
        type: 'gallery',
    };
    var newAttachments;
    if (((_a = gallery.images) === null || _a === void 0 ? void 0 : _a.length) >= 2) {
        newAttachments = __spreadArray(__spreadArray([], attachments.filter(function (attachment) {
            return !(attachment.type === 'image' && !(attachment.og_scrape_url || attachment.title_link));
        })), [
            gallery,
        ]);
    }
    else {
        newAttachments = attachments;
    }
    var propsWithDefault = __assign({ AttachmentActions: AttachmentActions,
        Audio: Audio,
        Card: Card,
        File: File,
        Gallery: Gallery,
        Image: Image,
        Media: Media }, rest);
    return (React.createElement(React.Fragment, null, newAttachments === null || newAttachments === void 0 ? void 0 : newAttachments.map(function (attachment) {
        if (isGalleryAttachment(attachment)) {
            return renderGallery(__assign(__assign({}, propsWithDefault), { attachment: attachment }));
        }
        if (isImageAttachment(attachment)) {
            return renderImage(__assign(__assign({}, propsWithDefault), { attachment: attachment }));
        }
        if (isFileAttachment(attachment)) {
            return renderFile(__assign(__assign({}, propsWithDefault), { attachment: attachment }));
        }
        if (isAudioAttachment(attachment)) {
            return renderAudio(__assign(__assign({}, propsWithDefault), { attachment: attachment }));
        }
        if (isMediaAttachment(attachment)) {
            return renderMedia(__assign(__assign({}, propsWithDefault), { attachment: attachment }));
        }
        return renderCard(__assign(__assign({}, propsWithDefault), { attachment: attachment }));
    })));
};
